import { useModalAction, useModalState } from "@/contexts/modal/Context";
import { ExerciseTODO, LoginUserItem } from "@/types";
import PrinterIcon from "@/components/icons/exercise/PrinterIcon.tsx";
import SpeakerOffIcon from "@/components/icons/exercise/SpeakerOffIcon.tsx";
import TimerIcon from "@/components/icons/exercise/TimerIcon.tsx";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import { useDownload } from "@/utils/hooks/useDownload.ts";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import { t } from "i18next";
import { Trans } from "react-i18next";
import Button from "@edusogno/primitives/button";
import { useMe } from "@/data/user";
import { maixpanelTrackEventProps } from "@/mixpanel/MixpanelUtils";

export default function DoExerciseModal() {
  const { me } = useMe();
  const { data } = useModalState();
  const { closeModal } = useModalAction();

  const { name, type, timer, id, token } = data as ExerciseTODO;
  const { download } = useDownload();
  const navigate = useNavigate();

  const breakpoint = useBreakpoint();
  const isXS = ["xs", "sm"].indexOf(breakpoint) !== -1;
  const handleStart = () => {
    closeModal();
    navigate(`${routes.exercises}/${type?.toLowerCase()}/${token}`);
  };
  
  // mixpanel integration
  const mixpanelPropsData = JSON.stringify(
    maixpanelTrackEventProps("Exercise: Do Modal", me?.item?.user as LoginUserItem),
  );

  if (isXS) {
    return (
      <h2 className="text-2xl font-semibold lg:text-3xl text-brand">
        {/* Use your laptop */}
        {t("exercises.use_your_laptop")}
      </h2>
    );
  }

  return (
    <div>
      <div className="flex flex-col items-stretch justify-between h-full gap-4">
        <div className={"flex flex-col justify-start h-full gap-4 "}>
          <div className="flex flex-col">
            <h5 className={"text-2xl text-primary font-semibold"}>{name}</h5>
            <div className={"flex flex-row text-[14px] gap-2"}>
              <p className={"font-normal"}>{t("exercises.duration")}:</p>
              <b className={"font-semibold text-brand-secondary"}>{`  ${
                type?.toLowerCase() === "listening" ? timer + 32 : timer
              } minutes`}</b>
            </div>
          </div>
          <div className={"flex flex-col pl-4"}>
            <div className={"flex flex-row gap-4 items-center"}>
              <PrinterIcon className="w-auto fill-brand-secondary h-9" />
              <p className={"text-sm font-normal text-brand"}>
                {type?.toLowerCase() === "grammar" ? (
                  <>
                    <Trans
                      i18nKey={"exercises.modal.grammar"}
                      components={{
                        b: <b className={"font-semibold"} />,
                      }}
                    />
                  </>
                ) : (
                  <Trans
                    i18nKey={"exercises.modal.print"}
                    components={{
                      bs: <b className={"font-semibold"} />,
                      b: <b />,
                    }}
                  />
                )}
              </p>
            </div>
            <div className={"flex flex-row gap-4 items-center"}>
              <SpeakerOffIcon className="w-auto fill-brand-secondary h-9" />
              <Trans
                i18nKey={"exercises.modal.speaker"}
                components={{
                  b: <b className={"font-semibold"} />,
                  p: <p className={"text-sm font-normal text-branda my-4"} />,
                }}
              />
            </div>
            <div className={"flex flex-row gap-4 items-center "}>
              <TimerIcon className="w-auto stroke-brand-secondary h-9" />
              <Trans
                i18nKey={"exercises.modal.timer"}
                components={{
                  b: <b className={"font-semibold"} />,
                  p: <p className={"text-sm font-normal text-brand"} />,
                }}
              />
            </div>
          </div>
        </div>
        <div
          className={
            "flex flex-row items-center gap-6 justify-center mt-2 w-full"
          }
        >
          <Button 
            data-track-props={mixpanelPropsData}
            data-track-eventtype={`Excersie_${t("btns.print")}`}
            variant={"outlined"} onClick={() => download({ id })}>
            {/* Print */}
            {t("btns.print")}
          </Button>
          <Button
            data-track-props={mixpanelPropsData}
            data-track-eventtype={`Excersie_${t("btns.start")}`}
            onClick={handleStart}>{t("btns.start")}
          </Button>
        </div>
      </div>
    </div>
  );
}
